import React from 'react';
import '../styles/BtnBack.css';
import Anime from 'react-anime';

export const BtnIcon = () => {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <path
        d="M15 5L8 12L15 19"
        stroke="#000000"
        strokeWidth="2.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

const BackToHomeBtn = (props) => {
  return (
    <Anime easing="easeInSine" elasticity={800} duration={500} scale={[0, 1]}>
      <button
        type="button"
        onClick={props.handleClick}
        className="btn-back"
        aria-label="Back to home"
      >
        <BtnIcon />
      </button>
    </Anime>
  );
};

export default BackToHomeBtn;
